<template>
  <div style="margin-top: 60px">
    <div class="newsbanner">
      <div class="newsbannerp1"><span>{{thename}}</span></div>
      <div class="newsbannerp2"><span>{{theTime}}</span></div>
    </div>
    <div class="content">
      <div class="arrowbanner">
        <span class="arrowbannerA" @click="backToBoforePage">资讯热点</span>
        <span>></span>
        <span class="theNewsTitle">{{thename}}</span>
      </div>
      <div class="theArtical">
        <div class="theArticalP" v-html='thecontd'>{{thecontd}}</div>
      </div>
    </div>
    <img :src="backToTop" alt="" class="backToTop" @click="backToTopclick" v-show="ifShowBackToTop"/>
  </div>
</template>

<script>
  import Request from '../common/request.js';

  var _this;
  var request = new Request();
  export default {
    name: 'NewsinfoPage',
    data: function () {
      return {
        theN: 0,
        thename: '',
        theTime: '',
        theSummary: '',
        ifShowBackToTop: false,
        newsinfopic1: '',
        thecontd: '',
        backToTop: '../static/resource/backToTop.png'
      }
    },
    methods: {
      backToBoforePage: function () {
        window.history.back();
      },
      getData: function () {
        return this.$route.query.theInfoNum
      },
      getData1: function () {
        return this.$route.query.passPageNum
      },
      backToTopclick: function () {
        $('html, body').animate({scrollTop: 0}, 500);
      },
      handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        scrollTop > 200 ? this.ifShowBackToTop = true : this.ifShowBackToTop = false;
      },
      getajaxdata: function () {
        request.get({
          url: '/mengyang/information/loadInformation',
          params: {
            id: _this.theN
          },
          callback(data) {
            _this.thename = data.data[0].name;
            _this.theTime = data.data[0].createTimetr;
            _this.theSummary = data.data[0].summary;
            _this.newsinfopic1 = data.data[0].viewImg;
            _this.thecontd = data.data[0].content;
          }
        })
      }
    },
    created: function () {
    },
    activated: function () {
      this.theN = this.getData();
      this.getajaxdata();
    },
    mounted: function () {
      _this = this;
      window.addEventListener('scroll', this.handleScroll)
      this.theN = this.getData()
      this.getajaxdata();
    }
  }
</script>

<style>
  .newsbanner {
    height: 224px;
    width: 100%;
    background: #74e5fe;
    text-align: center;
  }

  .newsbannerp1 {
    color: #666666;
    font-size: 36px;
    font-family: myFont;
    height: 60px;
    width: 100%;
    padding-top: 60px;
  }

  .newsbannerp2 {
    color: #666666;
    font-size: 22px;
    font-family: myFont;
    height: 50px;
    width: 100%;
  }

  .content {
    width: 1204px;
    height: auto;
    margin: 0 auto;
  }

  .arrowbanner {
    color: #969696;
    font-size: 22px;
    font-family: myFont;
    padding-top: 46px;
    padding-bottom: 24px;
  }

  .arrowbannerA {
    color: #969696;
    font-size: 22px;
    font-family: myFont;
  }

  .arrowbannerA:hover {
    color: black;
    cursor: pointer;
  }

  .theArtical {
    box-sizing: border-box;
    padding-top: 30px;;
    padding-bottom: 50px;
    background: #f6f6f6;
    min-height: 700px;
  }

  .theArticalP {
    text-indent: 2em;
    font-size: 24px;
    color: #666666;
    font-family: myFont;
    box-sizing: border-box;
    padding-left: 37px;
    padding-right: 37px;
    word-break: break-all;
  }

  .newsinfopic {
    width: 656px;
    height: 438px;
    margin-left: 50%;
    transform: translate(-50%);
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .theBottom {
    position: fixed;
    bottom: 0;
    height: 40px;
    width: 100%;
    background: #282828;
    z-index: 100;
  }

  .theBottom img {
    height: 40px;
  }

  .backToTop {
    position: fixed;
    top: 50%;
    left: 100%;
    transform: translate(-100%);
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/newsInfoPage.vue